import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

/**
 * This is a wrapper over `react-router/useNavigate` hook.
 * We use this to help us maintain consistency between CRA and Next.js
 */
export const useRouter = () => {
  const navigate = useNavigate();

  return useMemo(() => {
    return {
      back: () => navigate(-1),
      forward: () => navigate(1),
      refresh: () => navigate(0),
      push: (href, options) => navigate(href),
      replace: (href, options) => navigate(href, { replace: true }),
      prefetch: (href) => {},
      newWindow: (url, width = 1200, height = 800) => {
        const features = [
          `width=${width}`,
          `height=${height}`,
          "top=100",
          "left=100",
          "toolbar=no",
          "menubar=no",
          "scrollbars=yes",
          "resizable=yes",
          "location=no",
          "status=no",
        ].join(",");
        window.open(url, "_blank", features);
      },
    };
  }, [navigate]);
};
